export default __webpack_public_path__ + "static/media/chinaFlag.fab1fa2c.svg";